export default __webpack_public_path__ + "static/brewmeister-5b6720d04181d3cb818d8a1a5aa88eee.gif";